import { SET_SETTING, RESET_SETTING } from './actionTypes';

export const initialState = {
	hasInvoice: false,
	hasFinalOrder: false,
	hasTempOrder: false,
	showEditOrderButton: false,
	showCancelEditOrderButton: false,
	editMode: false,
	orderMessage: null,
};

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case SET_SETTING:
			return {
				...state,
				...payload,
			};
		case RESET_SETTING:
			return initialState;
		default:
			return state;
	}
};
